/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_AddInputs */

const cs_contacts_add = /** @type {(inputs: Contacts_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat kontakt`)
};

const en_contacts_add = /** @type {(inputs: Contacts_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add contact`)
};

/**
* | output |
* | --- |
* | "Add contact" |
*
* @param {Contacts_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_add = /** @type {((inputs?: Contacts_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_add(inputs)
	return cs_contacts_add(inputs)
});